<script>
import { getObjects } from '@/api/index'

export default {
  data() {
    return {
      object: ''
    }
  },
  created() {
    this.initPageData()
  },
  methods: {
    initPageData() {
      getObjects({  typeid: 0, id: 306, uid: 0 }).then(res => {
        if (res.code === 0) {
          this.object = res?.msg?.memo || '暂无'
        }
      })
    }
  }
}
</script>

<template>
  <div class="objects-container">
    <img class="objects-bg" :src="require('@/assets/index/objects-bg.png')" alt="objects">
    <div class="main-content">
      <p v-html="object"></p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.objects-container {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-size: 0.3rem;
  padding-top: 0.9rem;
  overflow-y: scroll;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  .objects-bg {
    width: 7.5rem;
    height: 5.21rem;
    position: absolute;
    top: 0.2rem;
    z-index: -1;
  }
}
.main-content {
  width: 7.1rem;
  background-color: #fff;
  min-height: 9rem;
  padding: 0.4rem 0.3rem 0.5rem;
  margin-top: 2.56rem;
  border-radius: 0.2rem 0.2rem 0 0;
}
</style>

